module.exports = __webpack_public_path__ + "img/homePage1.f08d4419.png";